var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49400",
    "data-name": "Group 49400",
    transform: "translate(-3132.115 8280.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(3132.865 -8279.5)",
    fill: "none",
    stroke: "#ffcd18",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(3135.027 -8273.5)",
    fill: "#ffcd18",
    stroke: "#ffcd18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(3138.615 -8273.5)",
    fill: "#ffcd18",
    stroke: "#ffcd18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(3142.204 -8273.5)",
    fill: "#ffcd18",
    stroke: "#ffcd18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgess);
export default __webpack_public_path__ + "static/media/In-progess.a7ced233bdd3069f018cfb85df7b6bd3.svg";
export { ForwardRef as ReactComponent };